export const SUPORTE = 8;
export const BASICO = 9;
export const ESSENCIAL = 10;
export const ELITE = 11;
export const FLUXO = 5;
export const APP = 6;
export const ACOMPANHAMENTO_PREMIUM = 13;

export const PREMIUM_MINIMUM_AMOUNT = 399.90;
